import { AlertColor } from "@mui/material";
import { AlertMessage } from "features/common/components/AlertMessage";
import { NavMenu } from "features/common/components/NavMenu";
import {
  NavButtonConfig,
  NavMenuConfig,
} from "features/common/components/NavMenu/NavMenu.types";
import { Spinner } from "features/common/components/Spinner";
import { ImportsTable } from "../ImportsTable";

export interface UserPanelContentProps {
  navMenuConfig: NavMenuConfig;
  handleClick: (btnConfig: NavButtonConfig) => () => void;
  userGrantsError: string;
  userGrantsIsFetching: boolean;
  refetchUserGrants: () => void;
  showAlertMessage: boolean;
  alertSeverity: AlertColor;
  alertMessage: string;
  fileTsError: string;
}

export const UserPanelContent = ({
  navMenuConfig,
  handleClick,
  userGrantsError,
  userGrantsIsFetching,
  refetchUserGrants,
  fileTsError,
  showAlertMessage,
  alertSeverity,
  alertMessage,
}: UserPanelContentProps) => {
  return (
    <>
      {userGrantsIsFetching && (
        <Spinner data-testid="spinner" height="100%" width="100%" />
      )}

      {Object.keys(navMenuConfig).length > 0 && (
        <NavMenu config={navMenuConfig} onClick={handleClick} />
      )}

      <ImportsTable />

      {!userGrantsIsFetching && (
        <AlertMessage
          isPermanent
          show={!!fileTsError}
          severity="error"
          message={fileTsError}
          hasAction={!!fileTsError}
        />
      )}

      <AlertMessage
        isPermanent
        show={showAlertMessage}
        severity={alertSeverity}
        message={alertMessage}
        hasAction={!!userGrantsError}
        actionMessage="Try Again"
        onClose={refetchUserGrants}
      />
    </>
  );
};
